<template>
	<div class="sticky-button-reserve-space">
		<section
			class="button-container"
			:class="{ dark: dark }"
			ref="stickyButton"
		>
			<TnButton
				v-bind="button"
				:size="$store.getters.isMobile ? 's' : 'l'"
				class="button"
				:dark="dark"
				:data-comp-lead="bedriftLead"
				:data-comp-cat="bedriftCategory"
			/>
		</section>
		<Transition name="slide-up">
			<section
				v-show="stickToBottom"
				class="sticky-button sticked"
				:class="{ dark: isDarkPage }"
			>
				<div class="sticky-container">
					<div class="left">
						<TnButton
							v-if="content && content.closeSticky"
							class="close-button"
							iconOnly="remove"
							:dark="isDarkPage"
							rounded="false"
							tertiary
							size="xs"
							@click="close"
						/>
						<div
							v-if="(content && content.text) || button.stickyText"
							class="text"
						>
							<TnParagraph
								bold
								:dark="isDarkPage"
								:size="$store.getters.isMobile ? 's' : 'l'"
							>
								{{ (content && content.text) || button.stickyText }}
							</TnParagraph>
						</div>
					</div>
					<TnButton
						v-bind="button"
						:size="$store.getters.isMobile ? 's' : 'l'"
						class="the-sticky-button"
						:dark="isDarkPage"
						:data-comp-lead="bedriftLead"
						:data-comp-cat="bedriftCategory"
					/>
				</div>
			</section>
		</Transition>
	</div>
</template>

<script>
import LinkViewModel from "../../../../helpers/ViewModels/LinkViewModel.js";
import { usePageStore } from "~/pinia/platform/page.ts";
import { mapState } from "pinia";
export default defineNuxtComponent({
	name: "StickyButton",

	props: {
		component: {
			type: Object,
		},
		productOrderButton: { type: Object },
		dark: { type: Boolean, default: false },
	},

	data() {
		return {
			stickToBottom: false,
			content: this?.component?.content,
			button:
				(this?.component?.content?.button && LinkViewModel(this?.component?.content?.button)) ||
				this.productOrderButton,
			buttonOffset: 0,
			initialized: false,
			bedriftLead: this?.component?.metadata && this?.component?.metadata?.lead,
			bedriftCategory: this?.component?.metadata && this?.component?.metadata?.category,
		};
	},

	computed: {
		...mapState(usePageStore, ["page"]),
		stickyButton() {
			return this.$refs.stickyButton;
		},
		isDarkPage() {
			return this.page.schema?._id.includes("twe");
		},
	},

	mounted() {
		this.initStickyButton();
		window.onload = this.initStickyButton; // Re-calculate sticky button to compensate for loaded pictures etc
		window.addEventListener("resize", this.initStickyButton);
		window.addEventListener("scroll", this.scrollListener);
	},

	methods: {
		initStickyButton() {
			this.initialized = true;
			if (this.stickToBottom) {
				this.stickToBottom = false;
			}

			this.buttonOffset = this.stickyButton.getBoundingClientRect().bottom + window.pageYOffset;
			this.scrollListener();
		},
		close() {
			this.stickToBottom = false;
			window.removeEventListener("resize", this.initStickyButton);
			window.removeEventListener("scroll", this.scrollListener);
		},
		scrollListener() {
			if (this.initialized) {
				const bottom = window.pageYOffset;
				if (bottom >= this.buttonOffset && !this.stickToBottom) {
					this.stickToBottom = true;
				} else if (bottom < this.buttonOffset && this.stickToBottom) {
					this.stickToBottom = false;
				}
			}
		},
	},

	beforeUnmount() {
		this.close();
	},
});
</script>

<style lang="scss" scoped>
.sticky-button-reserve-space {
	z-index: 2;
	display: inline-block;
}

.sticky-button {
	&.sticked {
		background: $color-primary-superlight;
		box-shadow:
			0 0 4px -2px rgb(0 0 0 / 12%),
			0 2px 8px 0 rgb(0 0 0 / 8%),
			0 4px 12px 0 rgb(0 0 0 / 4%);
		position: fixed;
		width: 100%;
		bottom: 0;
		left: 0;
		z-index: 1;
		margin-bottom: 0;
		padding: 0;
		padding-bottom: env(safe-area-inset-bottom, 0);

		&.dark {
			background: $color-neutrals-700-shade;
		}
	}

	.sticky-container {
		display: flex;
		flex-wrap: nowrap;
		gap: $spacing-s;
		justify-content: space-between;
		align-items: center;
		max-width: 1190px; // todo: update this when design has decided
		margin: 0 auto;
		padding: $spacing-m 15px;
		position: relative;

		.left {
			display: flex;
			flex-wrap: nowrap;
			justify-content: flex-start;
			align-items: center;
			gap: $spacing-s;

			.close-button {
				flex-grow: 0;
				flex-shrink: 0;
				justify-self: flex-end;

				+ .text {
					@include breakpoint(mobile) {
						margin-right: 0;
					}
				}
			}
		}

		@include breakpoint(mobile) {
			padding: $spacing-s;
		}
	}
}

.button-container {
	display: flex;
	justify-content: space-between;
	align-items: center;

	@include breakpoint(mobile) {
		flex-direction: column;
		gap: $spacing-m;
		align-items: flex-start;
	}
}

.slide-up-enter-active,
.slide-up-leave-active {
	transition: all 0.3s ease;
}

.slide-up-enter-from,
.slide-up-leave-to {
	transform: translateY(100%);
	opacity: 0;
}
</style>
